<template>
  <tr>
    <td class=""><span v-if="role === 'manager'" class="dot dot-yllow"
                       :class="(' score-bc-'+truncate(user.average,0)+' score-c-'+truncate(user.average,0))"></span>
      {{ user.lastname }}
    </td>
    <td>{{ user.firstname }}</td>
    <td>{{ user.birthdate ? calcAge(user.birthdate) : '-' }}</td>
    <!--                                <td><span v-for="(team,i) in user.teams">{{i > 0 ? ', ' : ''}}{{team.Title}}</span></td>-->
    <td><span>{{ user.team }}</span></td>
    <td class="u-evaldate">{{ user.lastreviewed ? toReadableDate(new Date(user.lastreviewed)) : '--/--/---' }}</td>
    <td class="u-score" v-if="role === 'manager'">
      <span class="score score-four"
            :class="((user.vipscore % 1 > 0 ? 'small' : '')+' score-bc-'+truncate(user.vipscore,0)+' score-c-'+truncate(user.vipscore,0))">
        {{ truncate(user.vipscore, 1) }}
      </span>
    </td>
    <td class="u-actions">


      <button v-if="role === 'manager'"
              @click.prevent="emitCurrent($event)"
              class="btn"
              :disabled="!current"
              :class="!current ? 'disabled' : ''"
              id="btn-vitamins">
        <img class="img-fluid"
             src="@/assets/images/user-list-manager/vitamins.svg"
             alt="Icon vitamins">
      </button>

      <!-- todo check if current user is manager-->
      <router-link v-if="role === 'manager'" tag="button" :role="'manager'"
                   :userid="user.id" :to="'/evolution/'+user.id"
                   class="btn btn" id="btn-settings">
        <img class="img-fluid"
             src="@/assets/images/user-list-manager/settings.svg"
             alt="Icon settings">
      </router-link>
      <!-- todo check if current user is HR-->
      <button v-if="role === 'hr'" @click.prevent="sendUser(user)" class="btn btn">
        <img class="img-fluid"
             src="@/assets/images/user-list-manager/edit.svg"
             alt="Icon edit">
      </button>
      <button v-if="role === 'hr'" @click.stop.prevent="forgotPassword($event,user)" class="btn btn d-flex-inline align-items-center align-content-center">
        <!--        <span class="pt-2">-->
        <span class="d-block fa-layers fa-fw" style="font-size:120%">
          <i class="fal fa-undo"></i>
          <i class="fas fa-key" data-fa-transform="shrink-8"></i>
        </span>
        <!--        </span>-->
      </button>
    </td>
  </tr>
</template>

<script>
import store from "../../store/store";

export default {
  created() {
    if (this.role !== 'hr') {
      this.getCurrentVitaminIdForUser(this.user.id)
    }
  },
  props: {
    role: {
      type: String, default() {
        return ''
      }
    },
    user: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data() {
    return {
      current: null
    }
  },
  methods: {
    async forgotPassword(e, user) {

    //  console.log('clicked f',e)
      const el = e.target;
      el.classList.add('loading');
      this.errors = [];

      store.dispatch('forgotPassword', {email: user.email})
        .then(r => {
          this.errors.push(this.$t('message.reset_mail_sent'))
          // console.log('re', r)
          this.loadingSuccess(el)
        })
        .catch(e => {
          el.classList.remove('loading');
     //     console.log('error', e.response.data.message)
          const messages = e.response.data.message;
        })
    },
    // resetPass(user) {
    //   console.log('reset pass for user', user)
    // },
    emitCurrent(evt) {
   //   console.log('emit current', this.current)
      if (Array.isArray(this.current)) {
        this.current = this.current[0]
      }
      const data = {user: this.user, current: this.current};
     // console.log('emitting current for user', [data, evt]);
      if (this.current) {
        this.$emit('showCurrentForUser', data);
      }

    },
    sendUser(id) {
      this.$emit('getUser', id);
    },

    async getCurrentVitaminIdForUser(uid) {
      const vit = await this.getCurrentVitamin(uid);
   //   console.log('vit', vit)
      this.current = vit;
   //   console.log('current for uid', [uid, vit])
    },
  }
}
</script>

<style scoped>
.btn-disabled img, .btn-disabled {
  opacity: .65;
}

.btn > * {
  pointer-events: none;
}

</style>



// WEBPACK FOOTER //
// src/components/Users/Userrow.vue